export enum ServerInitiatedTypeEnum {
  NONE,
  SCHEDULED,
  URGENT,
}
